<template>
  <div :class="[{ 'ms-popup-main': showModal }, 'ams-popup']" v-show="active" @keydown="onKeydown">
    <div class="popup-modal" v-if="showModal"></div>
    <msDragable
      ref="dragable"
      :w="widthx"
      :h="heightx"
      :z="zIndex"
      :x="posX"
      :y="posY"
      :isResizable="false"
      :isDraggable="isDraggable"
      @dragstop="offDraggable"
      :class="{
        'full-main-view flex-column': fullMainView,
        'left-menu-collapse': leftMenuCollapse,
        'right-menu-view': isRight,
      }"
    >
      <div
        @mousedown="onDraggable"
        class="ms-popup"
        :class="{
          'none-pop-modal': !showModal,
          'flex-column': flex,
          full: rendered,
          flex: fullMainView,
          'popup-sub-check': isSubContent,
        }"
        :style="{ height: height ? heightx + 'px' : 'auto' }"
        ref="popup"
      >
        <div class="buttons">
          <div v-if="showHelpIcon" class="button help" @click="helpLink"></div>
          <slot name="buttons-left"></slot>
          <div
            v-if="maximumable"
            class="button maximum"
            :class="{ full: maximum }"
            @click="maximumClick"
          ></div>
          <div
            v-if="showCloseIcon"
            class="button close"
            :class="classClose"
            @click="closePopup"
          ></div>
        </div>

        <!-- <div class="popup-header" @mousedown="onDraggable"> -->
        <div class="popup-header">
          <slot name="header"></slot>
        </div>
        <div class="popup-content" :class="[classListContent, { 'flex flex-column': flex }]">
          <slot name="content"></slot>

          <div class="loading" v-if="loading"></div>
        </div>
        <div
          class="popup-sub-content"
          v-if="subShow"
          :style="{ width: width + 'px', left: -width + 'px' }"
        >
          <slot name="sub-content"></slot>
        </div>
        <div
          class="btn-more-sub icon24 chevron-down"
          v-if="isSubContent"
          :class="{ open: subShow }"
          :style="{ right: moreLeft - 16 + 'px' }"
          @click="fnSubShow"
        ></div>
        <div class="popup-footer" :class="[classFooter]" v-if="showFooter">
          <slot name="footer"></slot>
        </div>
      </div>
    </msDragable>
  </div>
</template>
<script>
import msDragable from "@/components/msdragable/vue-drag-resize.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { ModuleContext } from "@/stores/module-const";
import commonFn from "@/commons/commonFunction";
export default {
  name: "MsPopup",
  components: {
    msDragable,
  },
  props: {
    //Trạng thái đóng mở popup
    active: {
      default: true,
      type: Boolean,
    },
    //Độ rộng của popup
    width: {
      default: 0,
      type: Number,
    },
    //Độ cao của popup
    height: {
      default: 0,
      type: Number,
    },
    //Cấu hình popup hiện thị full màn hình
    fullScreen: {
      default: false,
      type: Boolean,
    },
    //Cấu hình popup hiện thị full che lấp vừa khít với thẻ .main-view
    fullMainView: {
      default: false,
      type: Boolean,
    },
    isRight: {
      default: false,
      type: Boolean,
    },
    isSubContent: {
      default: false,
      type: Boolean,
    },
    showCloseIcon: {
      default: true,
      type: Boolean,
    },
    //ĐVThi 21/01/2021: Cấu hình có show Modle hay không, dùng cho form chi tiết vai trò
    showModal: {
      default: true,
      type: Boolean,
    },
    //ĐVThi 21/01/2021: Cấu hình động z-index: Do form popup lại gọi đến form popup khác dẫn đến cùng z-index dẫn đến bị ẩn về phía sau
    zIndex: {
      default: 1100,
      type: Number,
    },
    /**
     * Nếu bật cờ này thì nội dung sẽ flex theo popup
     */
    flex: {
      type: Boolean,
      default: false,
    },
    /**
     * Hiển thị footer
     */
    showFooter: {
      type: Boolean,
      default: true,
    },
    /**
     * Có icon maximum k
     */
    maximumable: {
      type: Boolean,
      default: false,
    },
    /**
     * Tự động đóng khi click vào nút đóng
     */
    autoClose: {
      type: Boolean,
      default: false,
    },
    /**
     * Trạng thái loading của cả popup
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Có icon help k
     */
    showHelpIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * link help
     */
    helpId: {
      type: String,
      default: "",
    },
    /**
     * class ở mục content
     */
    classListContent: {
      default: null,
      type: String,
    },
    classClose: {
      default: null,
      type: String,
    },
    classFooter: {
      default: null,
      type: String,
    },
  },
  //Tính toán lại độ rộng,độ cao,vị trí của popup và đưa element popup ra ngoài body
  created() {
    let me = this;
    me.updateSizePopup(me.fullScreen);
    window.addEventListener("resize", me.updateSizePopup);
  },
  mounted() {
    const me = this;
    document.body.appendChild(me.$el);

    me.$nextTick(() => {
      me.updateSizePopup(me.fullScreen);
    });
  },
  updated() {
    const me = this;
    me.$nextTick(() => {
      me.updateSizePopup(me.fullScreen);
    });
  },
  data() {
    return {
      isDraggable: false,
      widthx: 0,
      heightx: 0,
      maximum: false,
      rendered: false,
      subShow: false,
      moreLeft: this.width,
    };
  },
  computed: {
    // heightDefault() {
    //   const me = this;
    //   if (me.fullScreen || me.height) {
    //     return null;
    //   }
    //   return { height: "auto" };
    // },
    ...mapGetters({
      leftMenuCollapse: ModuleContext + "/LeftMenuCollapse",
    }),
  },
  watch: {
    posY(newVal, oldVal) {
      let x = 1;
    },
  },
  methods: {
    /**
     * Hiển thị sub content
     * CreatedBy: tmquy (21/06/2022)
     */
    fnSubShow() {
      const me = this;
      me.subShow = !this.subShow;
      if (me.subShow) {
        me.moreLeft = me.moreLeft * 2;
      } else {
        me.moreLeft = me.moreLeft / 2;
      }
      me.$emit("openSub");
    },
    /**
     * Cập nhật lại độ rộng vào độ cao của grid khi kích cỡ màn hình thay đổi
     * Created by LTDAT 26.06.2020
     */
    updateSizePopup(fullScreen) {
      let me = this,
        windowWidth = me.getWindowWidth(),
        windowHeight = me.getWindowHeight();
      if (fullScreen == true || me.maximum) {
        if (fullScreen == true) {
          me.lastHeight = me.height;
          me.lastWidth = me.width;
          me.maximum = true;
        } else {
          me.lastHeight = me.heightx;
          me.lastWidth = me.widthx;
        }

        me.widthx = windowWidth;
        me.heightx = windowHeight;
        me.posX = 0;
        me.posY = 0;
      } else {
        me.lastHeight = me.height;
        me.lastWidth = me.width;
        me.widthx = me.lastWidth || me.getPopupWidth() || windowWidth;
        me.heightx = me.lastHeight || me.getPopupHeight() || windowHeight;
        me.posX = Math.max((windowWidth - me.widthx) / 2, 0);
        me.posY = Math.max((windowHeight - me.heightx) / 2, 0);
      }

      //đánh dấu là đã render để xử lý style
      if (me.maximum && me.$el) {
        me.rendered = true;
      }
    },

    /**
     * move popup ra center window
     */
    center() {
      const me = this,
        windowWidth = me.getWindowWidth(),
        windowHeight = me.getWindowHeight();

      me.posX = Math.max((windowWidth - me.widthx) / 2, 0);
      me.posY = Math.max((windowHeight - me.heightx) / 2, 0);
    },

    getPopupWidth() {
      let width = this.width;
      if (this.$refs.popup && this.$refs.popup.offsetWidth) {
        width = this.$refs.popup.offsetWidth;
      }

      return width;
    },

    getPopupHeight() {
      let height = this.height;
      if (this.$refs.popup && this.$refs.popup.offsetHeight) {
        height = this.$refs.popup.offsetHeight;
      }

      return height;
    },

    /**
     * Lấy độ rộng của màn hình
     * Created by LTDAT 26.06.2020
     */
    getWindowWidth() {
      let windowWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      return windowWidth;
    },
    /**
     * Lấy độ cao của màn hình
     * Created by LTDAT 26.06.2020
     */
    getWindowHeight() {
      let windowHeight =
        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      return windowHeight;
    },

    /**
     * Xử lý sự kiện keydown trên popup
     * Created by LTDAT 26.06.2020
     */
    onKeydown(e) {
      const me = this;
      if (e.which == 27 && !e.cancel) {
        me.closePopup();
      }
    },
    /**
     * Sự kiện bắt đầu kéo di chuyển popup
     */
    onDraggable(event) {
      const me = this;
      if (
        !event.target.closest("input:not([disabled='disabled'])") &&
        !event.target.closest("input:not([readOnly='true'])") &&
        !event.target.closest("textarea:not([disabled='disabled'])") &&
        !event.target.closest("textarea:not([readOnly='true'])") &&
        !event.target.closest(".ms-dropdown") &&
        !event.target.closest(".ms-icon--dropdown") &&
        !event.target.closest(".icon-show--dropdown") &&
        !event.target.closest(".calendar") &&
        !event.target.closest(".ms-datepicker") &&
        !event.target.closest(".ms-mesage-box") &&
        !event.target.closest(".combo-dropdown-panel") &&
        !event.target.closest(".ms-dropdown") &&
        !event.target.closest(".ms-button") &&
        !event.target.closest("button") &&
        !event.target.closest(".button") &&
        !event.target.closest(".icon24") &&
        !event.target.closest(".scroller") &&
        !event.target.closest(".ms-resize") &&
        !event.target.closest(".range-slider-knob") &&
        !event.target.closest(".resizable-component")
      ) {
        if (!me.maximum) {
          me.isDraggable = true;
        }
      }
    },
    /**
     * Sự kiện thả di chuyển popup
     */
    offDraggable() {
      const me = this;
      me.$nextTick(() => {
        me.$refs.dragable.active = false;
        me.isDraggable = false;
      });
    },
    //SỰ kiện đóng popup
    closePopup() {
      const me = this;
      if (me.autoClose) {
        me.$emit("update:active", false);
      }
      me.$emit("close", false);
    },
    //SỰ kiện mở link help
    helpLink() {
      const me = this;
      let url = me.$ms.commonFn.helpAms(me.helpId);
      window.open(url, "_blank");
    },
    /**
     * click vào maximum
     */
    maximumClick() {
      const me = this;
      me.maximum = !me.maximum;
      me.updateSizePopup(false);
    },
  },
  beforeDestroy() {
    const me = this;
    window.removeEventListener("resize", me.updateSizePopup);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/msPopup.scss";
</style>
